module.exports = __webpack_public_path__ + "static/media/tattoine.418a12be.jpg";